<div class="select select--pristine select--bottom select--touched">
  <div class="select__dropdown-panel select--bottom select__dropdown-panel--open" [class.select__multiple]="multiple">
    <div *ngIf="selectAllOption">
      <div class="select__dropdown-panel-items scroll-host" wfmScrollbar>
        <div
          role="option"
          class="select__option"
          [class.select__option--selected]="selectedAll"
          (click)="toggleSelectAll()"
        >
          <span class="select__multiple-check-icon-wrapper" [class.select__multiple-hide-check-icon]="!selectedAll">
            <ng-container [ngTemplateOutlet]="checkIcon"> </ng-container>
          </span>
          <span class="select__option-label"> ({{ 'label.selectall' | translate }}) </span>
        </div>
      </div>
      <hr class="u-mv0" />
    </div>

    <div *ngIf="search" class="select__panel-header-input flex flex--middle">
      <input
        id="user-search-input"
        type="text"
        class="textbox u-pl---"
        placeholder="{{'label.typetosearch' | translate}}"
        [(ngModel)]="query"
        (ngModelChange)="updateFilteredItems()"
      />
      <button class="select__panel-header-input-icon select-search-icon">
        <svg-icon
          [ngStyle]="{ position: 'relative', top: '-8px' }"
          name="ico-filter-16"
          [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
        >
        </svg-icon>
      </button>
    </div>

    <div class="select__dropdown-panel-items scroll-host" #panelScroll wfmScrollbar>
      <div>
        <div *ngIf="multiple && highlightSelected">
          <ng-container *ngFor="let item of value; index as i">
            <ng-container [ngTemplateOutlet]="option" [ngTemplateOutletContext]="{ index: i, item: item }">
            </ng-container>
          </ng-container>
        </div>

        <ng-container *ngFor="let item of filteredItems || items; index as i">
          <ng-container *ngIf="grouping">
            <ng-container [ngTemplateOutlet]="groupOption" [ngTemplateOutletContext]="{ item: item }"> </ng-container>

            <ng-container *ngFor="let gItem of item.items; index as gi">
              <ng-container
                [ngTemplateOutlet]="option"
                [ngTemplateOutletContext]="{ index: '' + i + '-' + gi, item: gItem }"
              >
              </ng-container>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="!grouping">
            <ng-container [ngTemplateOutlet]="option" [ngTemplateOutletContext]="{ index: i, item: item }">
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<ng-template #option let-i="index" let-item="item">
  <div
    role="option"
    class="select__option"
    [ngStyle]="itemStyle"
    [class.select__option--sub-item]="grouping"
    [class.select__option--selected]="value && (value === item || (value.indexOf && value.indexOf(item) >= 0))"
    [class.select__option--disabled]="
      maxSelection && value && value.length === maxSelection && value.indexOf(item) === -1
    "
    (click)="itemClick(item)"
  >
    <span
      class="select__multiple-check-icon-wrapper"
      *ngIf="multiple"
      [class.select__multiple-hide-check-icon]="!value || value.indexOf(item) === -1"
    >
      <ng-container [ngTemplateOutlet]="checkIcon"> </ng-container>
    </span>

    <span class="select__option-label"> </span>
    <span class="select__option-label">
      <ng-container
        *ngIf="itemTemplate"
        [ngTemplateOutlet]="itemTemplate"
        [ngTemplateOutletContext]="{ index: i, item: item }"
      >
      </ng-container>
      <ng-container *ngIf="!itemTemplate">
        <span
          *ngIf="iconField && item && item[iconField]"
          [ngStyle]="{ 'margin-right': '5px', position: 'relative', top: '2px' }"
        >
          <svg-icon [name]="item[iconField]" [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }">
          </svg-icon>
        </span>
        <span id="{{'select-item'+(isListOfObjects ? item[labelField] : item)}}">{{ '' + (isListOfObjects ? item[labelField] : item) | translate }}</span>
      </ng-container>
    </span>
  </div>
</ng-template>

<ng-template #groupOption let-item="item">
  <div class="select__option select__option--group">
    <span>{{ item.label }}</span>
  </div>
</ng-template>

<ng-template #checkIcon>
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    class="select__multiple-check-icon"
    style="fill: currentColor"
  >
    <path
      d="M6.5,12.5a1,1,0,0,1-.71-.29l-3.5-3.5A1,1,0,1,1,3.71,7.29l2.79,2.8,5.79-5.8a1,1,0,1,1,1.42,1.42l-6.5,6.5A1,1,0,0,1,6.5,12.5Z"
    ></path>
  </svg>
</ng-template>
